$(document).ready(function () {
  $('#corporate_checkbox').on('change', function () {
    if ($(this).is(':checked')) {
      $('#corporate_fields').removeClass('hidden');
      $('[id$=_type]').val('User::Legal');
    } else {
      $('#corporate_fields').addClass('hidden');
      $('[id$=_type]').val('User::Natural');
    }
  });

  $(window).scroll(function () {
    if ($(document).scrollTop() > 100) {
      $('nav').addClass('resize');
      $('.marianne_reduced').css('display', 'inline-block');
      $('.marianne_reduced').css('opacity', '1');
      $('.marianne_extended').css('opacity', '0');
      $('.marianne_extended').css('display', 'none');
    } else {
      $('nav').removeClass('resize');
      $('.marianne_reduced').css('display', 'none');
      $('.marianne_reduced').css('opacity', '0');
      $('.marianne_extended').css('opacity', '1');
      $('.marianne_extended').css('display', 'inline-block');
    }
  });

  var submitIcon = $('.searchbox-icon');
  var inputBox = $('.searchbox-input');
  var searchBox = $('.searchbox');
  var isOpen = false;
  var toggleNavbarTitle = $('#toggleNavbarTitle');

  submitIcon.click(function () {
    if (isOpen == false) {
      searchBox.addClass('searchbox-open');
      inputBox.focus();
      isOpen = true;
      toggleNavbarTitle.addClass('opacity-0');
    } else {
      searchBox.removeClass('searchbox-open');
      inputBox.focusout();
      isOpen = false;
      toggleNavbarTitle.removeClass('opacity-0');
    }
  });

  submitIcon.mouseup(function () {
    return false;
  });

  searchBox.mouseup(function () {
    return false;
  });

  $(document).mouseup(function () {
    if (isOpen == true) {
      $('.searchbox-icon').css('display', 'block');
      submitIcon.click();
    }
  });

  function buttonUp() {
    var inputVal = $('.searchbox-input').val();
    inputVal = $.trim(inputVal).length;
    if (inputVal !== 0) {
      $('.searchbox-icon').css('display', 'none');
    } else {
      $('.searchbox-input').val('');
      $('.searchbox-icon').css('display', 'block');
    }
  }

  // contact form single page project
  $('.details-project')
    .children('.arrow')
    .on('click', function () {
      $('#owner-contact-form').slideToggle();
    });

  // wizard
  $('.create-account').on('click', function () {
    $(this).next('.form-toggle').slideToggle();
  });

  $('.existing-account').on('click', function () {
    $(this).next('.form-toggle').slideToggle();
  });

  $('.input-group-addon').on('click', function () {
    $('.reward-selected').each(function (index) {
      $(this).removeClass('reward-selected');
    });

    $(this).addClass('reward-selected');
    $('input[name="pre_subscription_checker[project_reward_id]"]').attr(
      'value',
      $(this).data('id')
    );

    var amount = parseInt($('#recap_amount_in_euros').text());
    var reward_amount = parseInt($(this).data('amount'));
    if (reward_amount && (!amount || amount < reward_amount)) {
      $('#pre_subscription_checker_amount').val($(this).data('amount'));
      $('#recap_amount_in_euros').text($(this).data('amount'));
    }
  });

  $('#pre_subscription_checker_amount').on('change paste keyup', function () {
    $('#recap_amount_in_euros').text($(this).val());
  });

  // smooth scroll // "voir les projets" bottom of slider
  $('.js-scrollTo').on('click', function () {
    // Au clic sur un élément
    var page = $(this).attr('href'); // Page cible
    var speed = 750; // Durée de l'animation (en ms)
    $('html, body').animate({ scrollTop: $(page).offset().top - 90 }, speed); // Go  // 70 for the header
    return false;
  });

  $('.js-prevent-default').on('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();

      var openModal = $(this).attr("data-open-modal");

      if ($(openModal).length > 0) {
        $(openModal).modal('show');
      }
    }
  });
});
